import { GetStaticProps } from "next";
import Head from "next/head";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useEffect, useState } from "react";
import {
    MwSmallIcon
} from "../../components/v2/icons";
import { getFirstFewPosts } from "../../lib/api";
import "../../styles/scss/partner.module.scss";
import "../../styles/scss/resources.module.scss";

const HERO_BG_SRC = "/images/contact-us/contact-us-bg.svg";
const HERO_BG_WIDTH = 1404;
const HERO_BG_HEIGHT = 443;

export default function Integrations({integrationPageData}) {
    const { t } = useTranslation("common");
    const allCategoryLabel = t('platform.integrations.left.allCategory');
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(allCategoryLabel);
    const [filteredIntegrations, setFilteredIntegrations] = useState([]);

    useEffect(() => {
        setSelectedCategory(allCategoryLabel);
    }, [allCategoryLabel]);

    useEffect(() => {
        // Filter integrations based on selected category and search query
        let allIntegrations = integrationPageData.allIntegrationCategories.edges.flatMap(({ node }) =>
            node.integration.edges.map(edge => ({ ...edge.node, category: node.name }))
        );

        if (selectedCategory !== allCategoryLabel) {
            allIntegrations = allIntegrations.filter(integration => integration.category === selectedCategory);
        }

        if (searchQuery) {
            allIntegrations = allIntegrations.filter(integration =>
                integration.title.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        setFilteredIntegrations(allIntegrations);
    }, [selectedCategory, searchQuery, integrationPageData]);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
        setSearchQuery('');
    };

    return (
        <>
            <Head>
                <link
                    rel="preload"
                    as="image"
                    href={HERO_BG_SRC}
                    {...({ fetchPriority: "high" } as any)}
                />
            </Head>
            <div className="partner-page integration-page resources-page">
                <div className={"hero-section"}>
                    <img
                        className="hero-section__bg"
                        src={HERO_BG_SRC}
                        alt=""
                        width={HERO_BG_WIDTH}
                        height={HERO_BG_HEIGHT}
                        fetchPriority="high"
                        loading="eager"
                        decoding="async"
                        aria-hidden="true"
                    />
                    <div className={"container"}>
                        <h1><span className={"text-gradient"}>{t('platform.integrations.hero.title')}</span>{t('platform.integrations.hero.titleSuffix')}</h1>
                        <p>{t('platform.integrations.hero.description')}</p>
                    </div>
                </div>

                <section className={'main-resources-whitepaper integrations'}>
                    <div className={'container'}>
                        <div className={"d-flex"}>
                            <div className={"left-block"}>
                                <div className={"left-resource"}>
                                    <div className={'section-tag testimonial'}><MwSmallIcon/> {t('platform.integrations.left.sectionTag')}</div>
                                    <h2>{t('platform.integrations.left.title')}</h2>
                                    <input
                                        type={"search"}
                                        placeholder={t('platform.integrations.left.searchPlaceholder')}
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                    <ul>
                                        <li
                                            className={selectedCategory === t('platform.integrations.left.allCategory') ? 'active' : ''}
                                            onClick={() => handleCategoryClick(t('platform.integrations.left.allCategory'))}
                                        >
                                            {t('platform.integrations.left.allCategory')}
                                        </li>
                                        {integrationPageData.allIntegrationCategories.edges.map(({node}) => (
                                            <li
                                                key={node.slug}
                                                className={selectedCategory === node.name ? 'active' : ''}
                                                onClick={() => handleCategoryClick(node.name)}
                                            >
                                                {node.name}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className={"right-block"}>
                                <div className={'content'}>
                                    <div className={'d-flex'}>
                                        {filteredIntegrations.length > 0 ? (
                                            filteredIntegrations.map((data, index) => (
                                                <div className={'inner-block'} key={index}>
                                                    <div className={'image-wrapper'}>
                                                        <img src={data.acf_integrations?.integrationImage?.sourceUrl}
                                                             alt={data.title} width={"100%"} height={"93%"}/>
                                                    </div>
                                                    <div className={"category knowledge"}>{data.category}</div>
                                                    <Link href={data.acf_integrations.knowMoreLink || '#'} target={"_blank"}>
                                                        <h3 className={'font-inter'}>{data.title}</h3>
                                                    </Link>

                                                </div>
                                            ))
                                        ) : (
                                            <div className="no-results">
                                                <p> {t('platform.integrations.right.noResults')}</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </>
    )
}

export const getStaticProps: GetStaticProps = async () => {
    const posts = await getFirstFewPosts();
    return {
        props: {
            posts,
        },
    };
};